angular.module('unergie.main')
.factory('StatusRenderer', ($rootScope, $window, $filter, $sce) =>
    function (status, filter) {
        let template
        const filterRes = $filter(filter)(status)
        if (filterRes) {
            let btnClass = 'btn-info'
            if (['erreur', 'error'].indexOf(filterRes.toLowerCase()) > -1) { btnClass = 'btn-danger' }
            if (['success', 'done', 'en service'].indexOf(filterRes.toLowerCase()) > -1) { btnClass = 'btn-success' }
            if (['partial'].indexOf(filterRes.toLowerCase()) > -1) { btnClass = 'btn-warning' }
            template = `<button class="btn ${btnClass}"> ${filterRes}</span>`
        }

        return $sce.trustAsHtml(template)
    },
)
